import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {NewsWidgetConfig} from "./news-widget.config";
import {NewsWidgetStore} from "./news-widget.store";
import {NewsWidgetHandlers} from "./handlers/news-widget.handlers";

export class NewsWidgetController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, NewsWidgetConfig, NewsWidgetStore, NewsWidgetHandlers];
}
